import get from 'lodash/get.js';

export default {
    state: {
        name: null,
        logo: null,
        timezone: null,
        course_preview_buffer: null,
        course_archive_buffer: null,
        course_grade_rounding: null,
        support_email: null,
        support_documentation_enabled: null,
        page_enabled: null,
        notifications_enabled: null,
        inbox_enabled: null,
        inbox_admin_only_access: null,
        reports_enabled: null,
        online_interval_check: null,
        timeline_enabled: null,
        risk_assessment_report_enabled: null,
        transcript_link: null,
        attestation_verbiage: null,
        identity_verification_enabled: null,
        evaluation_rating_schema: null,
        allow_users_to_edit_own_name: null,
        access_denied_helper_text: null,
    },

    getters: {
        get: state => field => get(state, field),
    },

    actions: {
        hydrate({ commit }, settings) {
            commit('SET', settings);
        },
    },

    mutations: {
        SET(state, settings) {
            Object.keys(state).forEach(key => {
                state[key] = get(settings, key);
            });
        },
    },
};
